import { render, staticRenderFns } from "./ContainSesameIcon.vue?vue&type=template&id=1a80ee3b&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports